import API from ".";
import { API_APPROVAL_SETTING_IMPORT } from "../constants/api";

async function importApprovalSettings(data) {
  const headers = {
    "Content-Type": "multipart/form-data",
  };

  try {
    const response = await API.post(API_APPROVAL_SETTING_IMPORT, data, {
      headers,
    });
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

export { importApprovalSettings };
